import { Reminder } from "./Reminder";

export class RemindersByCompany {
  constructor(
    public name?: string,
    public reminders?: Reminder[],
    public fullName?: string,
  ) {}

  expanded?: boolean;
}
